import React, { useMemo } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { ServicesPickerModal } from "../../../../boxes/ServicesPicker/ServicesPicker";
import { useAppTranslation } from "../../../../i18n/useAppTranslation";
import { useSaveDeviceServices } from "../hooks/useSaveDeviceServices";
import { uiNotification } from "../../../../services/UINotificationService";
import { QUERY_KEYS } from "../../../../consts/api";

const AssignServiceToEquipmentModal = ({
  id,
  onClose,
  servicesByCategory,
  isServicesLoading,
}) => {
  const { tCommon } = useAppTranslation.Common();
  const { mutate, isLoading } = useSaveDeviceServices(id);
  const queryClient = useQueryClient();

  const handleUpdate = (services) => {
    mutate(
      {
        services: services.map((s) => s.id),
      },
      {
        onSuccess: () => {
          onClose();
          uiNotification.success(tCommon("success.servicesAssign"));
          queryClient.invalidateQueries([QUERY_KEYS.deviceServicesAssigned]);
        },
        onError: () => {
          uiNotification.error(tCommon("error.servicesAssign"));
        },
      },
    );
  };

  const pickedServicesIds = useMemo(() => {
    return (
      servicesByCategory?.flatMap((category) =>
        category.services
          .filter((service) => service.is_assigned === true)
          .map((service) => service.id),
      ) || []
    );
  }, [servicesByCategory]);

  return (
    <ServicesPickerModal
      pickedIds={pickedServicesIds}
      isOpen
      onClose={onClose}
      onPick={handleUpdate}
      title="Assign Services to Equipment"
      pickTitle={tCommon("label.assign")}
      isPickLoading={isLoading}
      servicesByCategory={servicesByCategory}
      isServicesLoading={isServicesLoading}
    />
  );
};

export default AssignServiceToEquipmentModal;
